import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

export const ConversationSearchContext = React.createContext();

const ConversationSearchProvider = ({ children }) => {
    const [conversationSearchQuery, setConversationSearchQuery] = useState('');

    return (
        <ConversationSearchContext.Provider value={{ conversationSearchQuery, setConversationSearchQuery }}>
            {children}
        </ConversationSearchContext.Provider>
    );
};

ConversationSearchProvider.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

export default ConversationSearchProvider;
